import type {Nodes, Parent} from 'mdast'
import type {Handle} from 'mdast-util-from-markdown'

function isWhitespaceDelimiter(node: Nodes | undefined) {
  return node && node.type === 'delimiter' && node.tokenType === 'whitespace'
}

const handleExitHeading: Handle = function (this, token) {
  const openHeading = this.stack.at(-1)

  // We expect all headings to be the ## heading sequence immediately followed by a space
  if (openHeading?.type === 'heading' && !isWhitespaceDelimiter(openHeading.children[1])) {
    this.exit(token)

    // Previous must be a parent since it had a heading in it
    const parent = this.stack.at(-1) as Parent

    // Replace the heading with a paragraph in the parent
    parent.children.pop()
    parent.children.push({
      type: 'paragraph',
      position: openHeading.position,
      children: [],
    })

    return // **not** false, since we have fully handled this node by replacing it
  }

  return false
}

/**
 * mdast extension that prevents creating `heading` nodes for headings with no content. With this extension enabled,
 * ATX headings *must* have a space immediately after the opening sequence to be parsed.
 */
export function mdastSkipEmptyHeadings() {
  return {
    exit: {
      atxHeading: handleExitHeading,
    },
  }
}
